import {Controller} from "stimulus";

export default class extends Controller {

    connect() {
    }

    initialize() {
        $('#form-request-error').hide();
        this.url = this.data.get('url');
    }

    submitForm(submitEvent) {
        submitEvent.preventDefault();

        let container = $("#subscription-form-global");

        let formData = [];

        if (container) {
            $('#form-request-error').hide();
            let form = $('form', container);
            $('#newsletter_submit_btn').removeAttr('disabled');

            if (this.checkForRequiredField(form)) {
                if (!form[0].checkValidity()) {
                    form[0].reportValidity();
                    return;
                }

                formData = new FormData(form[0]);

                let _self = this;
                $.ajax({
                    url: _self.url,
                    data: formData,
                    method: 'POST',
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        var el = document.createElement('html');
                        el.innerHTML = response;

                        var success = response.success;
                        $('.login-section-holder').css('height', 'auto');
                        if (success) {
                            $('#form-message-error').hide();
                            $('#form-message-success').show();
                        } else {
                            $('#form-message-error').show();
                            $('#form-message-success').hide();
                        }

                    },
                    error: function (error) {
                        $('#form-message-error').show();
                        $('#form-message-success').hide();
                    }
                });
            }


        }
        submitEvent.returnValue = true;
    }
    showErrorText(errorText){
        $('#form-request-error .alert').text(errorText);
        $('#form-request-error').show();
    }
    checkForRequiredField(form){
        console.log(form);
        let _self = this;
        var isValid = true;
        form.find('.required').each(function (key,element){
            var elementType = $(element).attr('type');
            if(elementType === 'text' || elementType === 'email'){
                if ($(element).val() === '') {
                    _self.showErrorText($(element).data('error-message'));
                    isValid = false;
                }
            }
            if(elementType === 'checkbox' && isValid){
                if(!$(element).is(':checked')){
                    _self.showErrorText($(element).data('error-message'));
                    isValid = false;
                }
            }
        });

        return isValid;
    }
}

